import { connect } from 'react-redux';
import Actions from '../../actions';

import ManageKWallet from '../../components/pages/manage-k-wallet';

const pageWallet = 'kwallet'; // wallet por defecto con este conector, puede llevarse a la página y dejarlo limpio aquí

const mapStateToProps = (state, ownProps) => ({
    user: state.user,
    locale: state.locale,
    activeWallet: state.wallets[pageWallet],
    accessToken: state.auth.access_token,
});

const mapDispatchToProps = (dispatch) => ({
    fetchWalletTransactions: (token, params, wallet = pageWallet) => dispatch(Actions.fetchWalletTransactions(params, wallet, token)),
    fetchWalletDetails: (token, wallet = pageWallet) => dispatch(Actions.fetchWalletDetails(wallet, token)),
    isWalletActive: async (token, wallet = pageWallet) => {
        const active = await dispatch(Actions.activeWallet(wallet, token, true));
        return active;
    },
    activateWallet: async (token, wallet = pageWallet) => {
        const activate = await dispatch(Actions.activateWallet(wallet, token));
        return activate;
    },
    transferFunds: async (token, amount, idTransfer, wallet = pageWallet) => dispatch(Actions.transferWalletFunds({
        wallet, token, amount, idTransfer,
    })),
});

const ManageKWalletConnector = connect(mapStateToProps, mapDispatchToProps)(ManageKWallet);

export default ManageKWalletConnector;



/** WEBPACK FOOTER **
 ** ./src/containers/k-wallet/index.js
 **/